import React, { useEffect, useState } from "react";
import "./Badge.css";
import format from "date-fns/format";
import { it } from "date-fns/locale";
import { generateBadgePDF } from "./BadgeGenerator";

import { useAuthContext } from "../../hooks/useAuthContext";
import { useDocument } from "../../hooks/useDocument";
import logoGiuvi from "../../assets/logoHeader_red.png";

// Placeholder per la foto
const PLACEHOLDER_PHOTO = "https://via.placeholder.com/150";

export default function Badge() {
  const { user } = useAuthContext();
  const { document: userDoc } = useDocument("users", user.uid);

  const [userData, setUserData] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    if (userDoc) {
      // Estrai dati anagrafici o usa valori di default
      const anagrafica = userDoc.anagrafica || {};

      setUserData({
        nome: anagrafica.nome || user.displayName?.split(" ")[0] || "Nome",
        cognome:
          anagrafica.cognome ||
          user.displayName?.split(" ").slice(1).join(" ") ||
          "Cognome",
        ruolo:
          anagrafica.mansione ||
          userDoc.role ||
          (user.customClaims?.admin ? "Admin" : "Dipendente"),
        codiceFiscale: anagrafica.codiceFiscale || "---",
        dataNascita: anagrafica.dataNascita
          ? format(anagrafica.dataNascita.toDate(), "d MMM y", { locale: it })
          : "---",
        luogoNascita: anagrafica.luogoNascita || "---",
        email: user.email,
        foto: anagrafica.foto || user.photoURL || PLACEHOLDER_PHOTO,
        id: user.uid,
      });
    }
  }, [userDoc, user]);

  const handleDownload = async () => {
    if (!userData) return;

    setIsGenerating(true);
    try {
      await generateBadgePDF(userData);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Si è verificato un errore durante la generazione del PDF.");
    } finally {
      setIsGenerating(false);
    }
  };

  if (!userData) {
    return <div className="badge-loading">Caricamento badge...</div>;
  }

  return (
    <div className="badge-page-container">
      <div className="badge-card">
        <div className="badge-header">
          <div className="company-logo">
            <img
              src={logoGiuvi}
              alt="Logo Giuvi"
              className="company-logo-img"
            />
          </div>
          <div className="badge-type">Tesserino</div>
        </div>

        <div className="badge-content">
          <div className="badge-photo-section">
            <div className="photo-frame">
              <img
                src={userData.foto}
                alt={`${userData.nome} ${userData.cognome}`}
                className="user-photo"
                onError={(e) => {
                  e.target.src = PLACEHOLDER_PHOTO;
                }}
              />
            </div>
          </div>

          <div className="badge-info-section">
            <div className="info-group main">
              <h2 className="user-fullname">
                <span className="surname">{userData.cognome}</span>
                <span className="name">{userData.nome}</span>
              </h2>
              <p className="user-role">{userData.ruolo}</p>
            </div>

            <div className="badge-details-grid">
              <div className="info-details">
                <div className="section-title">Dati dipendente</div>
                <div className="detail-row">
                  <span className="label">Nato il:</span>
                  <span className="value">{userData.dataNascita}</span>
                </div>
                <div className="detail-row">
                  <span className="label">A:</span>
                  <span className="value">{userData.luogoNascita}</span>
                </div>
                <div className="detail-row">
                  <span className="label">C.F.:</span>
                  <span className="value">{userData.codiceFiscale}</span>
                </div>
              </div>

              <div className="company-details">
                <div className="section-title">Dati aziendali</div>
                <div className="detail-row">
                  <span className="label">Indirizzo</span>
                  <span className="value">
                    Via Belgirate, 15 - 20125 Milano
                  </span>
                </div>
                <div className="detail-row">
                  <span className="label">P.IVA/C.F.</span>
                  <span className="value">07873720960</span>
                </div>
                <div className="detail-row">
                  <span className="label">REA</span>
                  <span className="value">MI-2010873</span>
                </div>
                <div className="detail-row">
                  <span className="label">INPS</span>
                  <span className="value">PA 4978037989</span>
                </div>
                <div className="detail-row">
                  <span className="label">INAIL</span>
                  <span className="value">PAT 19083034/46</span>
                </div>
                <div className="detail-row">
                  <span className="label">Telefono</span>
                  <span className="value">+39 02 97 19 03 15</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="badge-actions">
        <button
          className="download-btn"
          onClick={handleDownload}
          disabled={isGenerating}
        >
          {isGenerating ? "Generazione PDF..." : "Scarica tesserino"}
        </button>
      </div>
    </div>
  );
}
